import { Link } from 'react-router-dom';
import SectionHeading from '@/components/base/SectionHeading';
import SceneCard from '@/components/feature/SceneCard';
import { scenes } from '@/mocks/scenes';

export default function FeaturedScenes() {
  const list = scenes.slice(0, 6);

  return (
    <section id="scenes" className="scroll-mt-24 bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-content px-4 md:px-6">
        <SectionHeading
          eyebrow="名场面精选"
          title="那些被反复回放的高能瞬间"
          description="从直播口误到群聊刷屏，我们把每一段最热闹的现场整理成一页，前因后果一次看明白。"
          action={
            <Link
              to="/topics"
              className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2.5 text-sm text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-600"
            >
              全部名场面
              <i className="ri-arrow-right-line" aria-hidden="true" />
            </Link>
          }
        />

        <div className="mt-8 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((scene, index) => (
            <SceneCard key={scene.id} scene={scene} rank={index + 1} />
          ))}
        </div>
      </div>
    </section>
  );
}